function pow(p) {
    if (p) {
        return Math.pow(10, p);
    }

    return 1;
}

export default function round(value, precision) {
    var power = pow(precision);
    return Math.round(value * power) / power;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/util/round.js
// module id = 650
// module chunks = 0